import React from 'react';
import {CommonShow} from '../Common';
import {getFields} from './Common';

export const MaterialShow = props => (
  <CommonShow
    {...{
      ...props,
      fields: getFields(),
    }}
  />
);
